import React from 'react';
import './Contact.css';

function Contact() {
    return (
        <div className="contact">
            <h2 data-aos="fade-up">Contact Me</h2>
            <p data-aos="fade-up" data-aos-delay="200">
                Feel free to connect with me on LinkedIn:
            </p>
            <a
                href="https://www.linkedin.com/in/tanmaymhaske"  // Replace with your LinkedIn profile URL
                target="_blank"
                rel="noopener noreferrer"
                className="linkedin-link"
                data-aos="zoom-in"
                data-aos-delay="400"
            >
                Visit My LinkedIn Profile
            </a>
        </div>
    );
}

export default Contact;